import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App.jsx';
import NotFoundPage from './NotFoundPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    {/* <NotFoundPage /> */}
  </React.StrictMode>
);
